import React from 'react'

const ContactUS = () => {
  return (
    <div>ContactUS</div>
  )
}

export default ContactUS